/**
 * @deprecated This service has been consolidated into src/services/github/GitHubService.ts
 * This file is maintained for backward compatibility only.
 * Please update imports to use: import { GitHubService } from './github';
 */

import { GitHubService } from './github/GitHubService';
import type { CodebaseAnalysis } from './github/GitHubService';

export class GitHubAnalysisService {
  /**
   * Analyze a GitHub repository and extract comprehensive project information
   */
  static async analyzeRepository(
    projectId: string,
    userId: string
  ): Promise<CodebaseAnalysis | null> {
    return GitHubService.analyzeRepository(projectId, userId);
  }
}
